import Vue from 'vue';
import type { NuxtI18nInstance } from 'nuxt-i18n';

interface StoreState {
  contentLang: string;
}

const state: StoreState = Vue.observable({
  contentLang: ''
});

class LanguageStore {
  get contentLang(): string {
    return state.contentLang;
  }

  public setupLang(
    systemLocale: string,
    contentLocale: string,
    i18n: NuxtI18nInstance
  ): string {
    let langCode = i18n.defaultLocale ?? 'da';
    const langParam = parseInt(
      new URLSearchParams(location.search).get('L') ?? ''
    );

    // L-var overrules locale in typo3 constants
    if (langParam && !isNaN(langParam)) {
      // Sanitize ...
      if (langParam >= 0 && langParam < 11) {
        langCode = i18n.localeCodes[langParam];
      }
    } else {
      langCode = systemLocale !== '' ? systemLocale : i18n.defaultLocale;
    }

    state.contentLang = contentLocale !== '' ? contentLocale : langCode;

    // Set locale if different from default
    if (langCode !== i18n.defaultLocale) {
      i18n.setLocale(langCode);
    }

    return langCode;
  }
}

export default new LanguageStore();
